const PAIRED_DEVICES_STATE_STATUSES = {
  EMPTY: 'EMPTY',
  LOADING: 'LOADING',
  ACTIVATING: 'ACTIVATING',
  REMOVING: 'REMOVING',
  NEED_REFRESH: 'NEED_REFRESH',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

export { PAIRED_DEVICES_STATE_STATUSES };
